import { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { fetchAllDemosForUsers } from "../../actions"
import { Tabs, TabList, Tab, TabPanels, TabPanel } from "neo-latest"
import { Spin } from 'antd';
import DemoCards from './DemoCards'
import { LoadingOutlined } from '@ant-design/icons';
import News from '../News';
import UserReports from '../common/UserReports';
import { Icon as NeoIcon } from "@avaya/neo-react";
const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

const MySpace = () => {
    const allUserDemos = useSelector(({ dashboard }) => dashboard?.allUserDemos || []);
    const [loading, setLoading] = useState(true);
    const [activeTab, setActiveTab] = useState(localStorage.getItem('dashboard-tab') ? parseInt(localStorage.getItem('dashboard-tab')) : 0)
    const dispatch = useDispatch();

    useEffect(() => {
        (async () => {
            await fetchDemos();
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
        //eslint-disable-next-line
    }, [])

    const fetchDemos = async () => {
        setLoading(true);
        await dispatch(fetchAllDemosForUsers());
        setLoading(false);
    }

    const empty = <div style={{ height: "150px" }} className='dashboard-no-schedules'><NeoIcon aria-label="menu-aria" icon="info" size='md' />No Demos assigned. <br /> Please contact the administrator.</div>;

    return (
        <Spin indicator={antIcon} spinning={loading}>
            <div style={{ marginTop: "3rem" }}>
                <Tabs index={activeTab} defaultIndex={0} onTabChange={(tab) => { setActiveTab(tab); localStorage.setItem('dashboard-tab', tab) }}>
                    <TabList>
                        <Tab id="myDemos">
                            My Demos
                        </Tab>
                        <Tab id="news">
                            News
                        </Tab>
                        <Tab id="reports">
                            Reports
                        </Tab>
                    </TabList>
                    <TabPanels>
                        <TabPanel>
                            <div>
                                {allUserDemos?.length > 0 ? <DemoCards fetchDemos={fetchDemos} items={allUserDemos || []} /> : empty}
                            </div>
                        </TabPanel>
                        <TabPanel>
                            <div style={{ marginBottom: "5rem" }}>
                                <News />
                            </div>
                        </TabPanel>
                        <TabPanel>
                            <UserReports />
                        </TabPanel>
                    </TabPanels>
                </Tabs>
            </div>
        </Spin>
    )
}

export default MySpace;